export default "__VITE_ASSET__942ae414__"